import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ChangeLength = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        role="img"
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M5.9274 2.72542L12.5062 1.5625C14.9317 5.25063 13.7059 10.5669 12.7423 12.5937C10.7819 13.1585 7.12355 14.1553 5.9274 14.2882C4.63499 14.6537 2.34243 14.9527 2.50856 11.1317C2.57769 9.54156 3.36948 8.17175 4.00679 8.11247L7.37907 7.33174C7.0892 5.72499 6.57213 4.09554 5.9274 2.72542Z"
          fill="white"
        />
        <path
          d="M5.9274 14.2882C7.12355 14.1553 10.7819 13.1585 12.7423 12.5937C13.7059 10.5669 14.9317 5.25063 12.5062 1.5625L5.9274 2.72542C7.78799 6.67937 8.58542 12.793 5.9274 14.2882ZM5.9274 14.2882C4.63499 14.6537 2.34243 14.9527 2.50856 11.1317C2.57769 9.54156 3.36948 8.17175 4.00679 8.11247M7.57355 11.1317L4.6346 11.8959C5.54635 9.78142 4.9009 8.02931 4.00679 8.11247M4.00679 8.11247L7.37907 7.33174"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.75513 4.81858L11.6126 4.15405M9.13723 6.84539L12.1941 6.04796M9.36982 8.77252L12.1941 8.05816M9.53595 10.899L11.8618 10.3009"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default ChangeLength
